/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_TitleInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_1_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open, edit and save an Excel workbook`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_1_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开、编辑并保存 Excel 工作簿`)
};

/**
* | output |
* | --- |
* | "Open, edit and save an Excel workbook" |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_1_title = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_1_title(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_1_title(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_1_title as "gc.search_guides.gridcraft_excel_compatibility.sections.1.title" }